import { Country } from "../model/Country";
import { getLogger } from "@goodgamestudios/logger";
import { filterCountriesByCountryCode, filterCountriesByGeoIpCode, filterCountriesByBrowserLanguage } from './CountryFilters';

const logger = getLogger("WorldAssignment.CountrySelector");

export const getCountryByCountryCode = (countries: Country[], countryCode: string): Country => {
    if (!countries || !countryCode) {
        logger.debug("CountrySelector.getCountryByCountryCode: error with countries || countryCode", countries, countryCode);
        return;
    }

    return filterCountriesByCountryCode(countries, countryCode)[0];
}

export const getCountryByGeoIpCode = (countries: Country[], geoIpCode: string): Country => {
    if (!countries || !geoIpCode) {
        logger.debug("CountrySelector.getCountryByGeoIpCode: error with countries || countryCode", countries, geoIpCode);
        return;
    }

    return filterCountriesByGeoIpCode(countries, geoIpCode)[0];
}

export const getCountryByBrowserLanguage = (countries: Country[], language: string): Country => {
    if (!countries || !language) {
        logger.debug("CountrySelector.getCountryByBrowserLanguage: error with countries || countryCode", countries, language);
        return;
    }

    return filterCountriesByBrowserLanguage(countries, language)[0];
}
